export const ID_ACTIVE_OPTION = 'active-option';
export const NUMBER_OF_COLUMNS_IN_SWATCH = 6;